//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum DynamoContentType {
	Panel = 0,
	Label = 1,
	IFrame = 2
}
